import React from 'react';
import styled from 'styled-components';
import Button from 'js/components/common/Button';

const Container = styled.div`
  padding: 0 1rem 1rem 0;
  grid-area: ${({ area }) => area};
`;

export default ({ area, ...rest }) => (
  <Container area={area}>
    <Button {...rest} />
  </Container>
);
